import { Component, HostListener, inject, OnDestroy, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { filter, Subject, takeUntil } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { Toast } from 'primeng/toast';
import { Meta } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import {
  EmiFooter,
  StatusModal,
  Spinner,
  SideNav,
  CookieConsent,
  ContactUs,
  EmiHeader,
  FaviconService,
  HeaderService,
  UserStore,
  searchRouteData,
  landingPageItems,
} from '@emilegal/emi-fe-common';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ButtonModule,
    TagModule,
    EmiFooter,
    Toast,
    StatusModal,
    Spinner,
    SideNav,
    CookieConsent,
    ContactUs,
    EmiHeader,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('Emi');
  protected readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private faviconService = inject(FaviconService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private headerService = inject(HeaderService);
  private metaService = inject(Meta);
  userStore = inject(UserStore);

  hideNav = signal(true);
  showHeader = signal(false);
  private unsubscribe$ = new Subject<void>();
  private readonly KEYWORDS =
    'ai agents, ai legal, ai workflows, secure ai, ai legal assistant, customized ai, pre-built agents';

  fixHeader = signal<boolean>(false);

  @HostListener('window:scroll')
  scrollListener() {
    this.fixHeader.set(window.scrollY > 62);
  }

  ngOnInit(): void {
    this.faviconService.listenForThemeChange();
    this.setHeaderItems();
    this.routeDataHandler();

    if (environment.production) {
      this.setKeywords();
    }
  }

  routeDataHandler() {
    this.router.events
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((e) => e instanceof NavigationEnd)
      )
      .subscribe(() => {
        const hideNav = searchRouteData(this.route, 'hideNav');
        const showHeader = searchRouteData(this.route, 'showHeader');
        this.hideNav.set(hideNav);
        this.showHeader.set(showHeader);
      });
  }

  private setHeaderItems() {
    this.headerService.setMenuItems(landingPageItems);
  }

  private setKeywords() {
    this.metaService.addTag({
      name: 'keywords',
      content: this.KEYWORDS,
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
